import { render, staticRenderFns } from "./MenuSpeechTherapist.vue?vue&type=template&id=1bbf3d0e&"
import script from "./MenuSpeechTherapist.vue?vue&type=script&lang=js&"
export * from "./MenuSpeechTherapist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports